module.exports = __webpack_public_path__ + "static/media/mode-72.fd6d39ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-72.svg
// module id = 1042
// module chunks = 2